import { Component } from '@theme/component';

class BlushmallowShop extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.abort?.abort();
    this.abort = new AbortController();
    this.labels = JSON.parse(this.querySelector('[data-blush-labels]').textContent);
    this.addEventListener('change', this.handleChange, { signal: this.abort.signal });
    this.addEventListener('click', this.handleGallery, { signal: this.abort.signal });
    this.addEventListener('submit', this.handleSubmit, { signal: this.abort.signal });
    this.selectionConfirmed = new URL(window.location.href).searchParams.has('variant');
    this.syncSelection();
    clearInterval(this.promoTimer);
    this.promoTimer = setInterval(() => this.syncPrices(), 1000);
  }
  updatedCallback() {
    super.updatedCallback();
    this.labels = JSON.parse(this.querySelector('[data-blush-labels]').textContent);
    this.syncSelection();
  }
  disconnectedCallback() {
    this.abort?.abort();
    clearInterval(this.promoTimer);
    super.disconnectedCallback();
  }
  handleChange = (event) => {
    if (event.target.matches('input[name="blush-color"], input[name="id"]')) this.selectionConfirmed = true;
    if (event.target.matches('input[name="blush-color"]')) {
      const bundle = this.querySelector('input[name="id"]:checked')?.dataset.bundle === 'solo' ? 'solo' : 'pair';
      const next = [...this.querySelectorAll('input[name="id"]')].find(input => input.dataset.color === event.target.value && input.dataset.bundle === bundle);
      if (next) next.checked = true;
      this.syncSelection();
    }
    if (event.target.matches('input[name="id"]')) this.syncSelection();
  };
  handleGallery = (event) => {
    if (event.target.closest('[data-sticky-add]') && !this.selectionConfirmed) {
      event.preventDefault();
      this.querySelector('.bm-color-picker')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      this.querySelector('input[name="blush-color"]')?.focus({ preventScroll: true });
      return;
    }
    const colorButton = event.target.closest('[data-choose-color]');
    if (colorButton) {
      const color = [...this.querySelectorAll('input[name="blush-color"]')].find(input => input.value === colorButton.dataset.chooseColor);
      color?.click();
      this.querySelector('.bm-color-picker')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    const his = event.target.closest('[data-choose-his]');
    if (his) {
      const input = this.querySelector('input[data-bundle="his-hers"]');
      if (input) { this.selectionConfirmed = true; input.checked = true; this.syncSelection(); this.querySelector('.bm-bundles').scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      return;
    }
    const button = event.target.closest('[data-gallery]');
    if (!button || !this.contains(button)) return;
    for (const item of this.querySelectorAll('[data-gallery]')) item.setAttribute('aria-pressed', String(item === button));
    for (const panel of this.querySelectorAll('[data-gallery-panel]')) panel.hidden = panel.dataset.galleryPanel !== button.dataset.gallery;
  };
  syncSelection() {
    const selected = this.querySelector('input[name="id"]:checked');
    if (!selected) return;
    const activeColor = selected.dataset.bundle === 'his-hers' ? (this.querySelector('input[name="blush-color"]:checked')?.value || 'Pink') : selected.dataset.color;
    for (const card of this.querySelectorAll('[data-card-color]')) card.hidden = card.dataset.cardColor !== 'Pink + Navy' && card.dataset.cardColor !== activeColor;
    for (const color of this.querySelectorAll('input[name="blush-color"]')) color.checked = color.value === activeColor;
    if (selected.dataset.colorImage) {
      for (const image of this.querySelectorAll('[data-gallery-panel="hoodie"] img, [data-gallery="hoodie"] img')) {
        image.src = selected.dataset.colorImage;
        image.removeAttribute('srcset');
        image.alt = `${selected.dataset.color} blanket hoodie`;
      }
      const hoodie = this.querySelector('[data-gallery="hoodie"]');
      if (selected.dataset.bundle === 'his-hers') this.querySelector('[data-gallery="couple"]')?.click();
      else if (this.initialized || selected.dataset.color !== 'Pink') hoodie?.click();
      this.querySelector('[data-color-caption]').textContent = `${selected.dataset.color} · ${this.labels.colorCaption}`;
    }
    this.querySelector('[data-selection-summary]').textContent = `${selected.dataset.color} · ${selected.closest('label').querySelector('.bm-bundle-body strong').textContent}`;
    this.initialized = true;
    this.syncPrices();
    this.querySelector('[data-gift-copy]').textContent = selected.dataset.bundle !== 'solo' ? this.labels.giftPair : this.labels.giftSolo;
    const quantity = this.querySelector('input[name="quantity"]');
    quantity.min = selected.dataset.min || '1';
    quantity.step = selected.dataset.step || '1';
    if (selected.dataset.max) quantity.max = selected.dataset.max;
    else quantity.removeAttribute('max');
    quantity.value = quantity.min;
    const url = new URL(window.location.href);
    if (url.pathname.includes('/products/')) {
      url.searchParams.set('variant', selected.value);
      window.history.replaceState({}, '', url);
    }
    this.setBusy(Boolean(this.pending));
    this.querySelector('[data-form-status]').textContent = '';
  }
  syncPrices() {
    const percent = Date.now() < Date.parse(this.dataset.promoEnd) ? 30 : 35;
    const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(cents / 100);
    const sale = (base) => money(Number(base) - Math.round(Number(base) * percent / 100));
    for (const price of this.querySelectorAll('[data-bundle-sale]')) {
      const unit = price.querySelector('[data-per-set]');
      const label = document.createTextNode(sale(price.dataset.bundleSale));
      price.replaceChildren(label);
      if (unit) {
        const base = Number(price.dataset.bundleSale);
        unit.textContent = `${money((base - Math.round(base * percent / 100)) / 2)} ${this.labels.perFit}`;
        price.append(unit);
      }
    }
    for (const ribbon of document.querySelectorAll('[data-sale-ribbon]')) ribbon.textContent = percent === 30 ? this.labels.ribbon30 : this.labels.ribbon35;
    const selected = this.querySelector('input[name="id"]:checked');
    if (selected) {
      this.querySelector('[data-current-price]').textContent = sale(selected.dataset.baseCents);
      this.querySelector('[data-sticky-price]').textContent = sale(selected.dataset.baseCents);
      this.querySelector('[data-regular-price]').textContent = selected.dataset.price;
      this.querySelector('[data-shipping-summary]').textContent = selected.dataset.bundle === 'solo' ? this.labels.shippingSolo.replace('{total}', money(Number(selected.dataset.baseCents) - Math.round(Number(selected.dataset.baseCents) * percent / 100))) : this.labels.shippingPair;
    }
    this.querySelector('[data-promo-copy]').textContent = percent === 30 ? this.labels.promo30 : this.labels.promo35;
  }
  setBusy(busy) {
    const available = this.querySelector('input[name="id"]:checked')?.dataset.available === 'true';
    for (const button of this.querySelectorAll('[data-add], [data-sticky-add], [data-add-secondary]')) {
      button.disabled = busy || !available;
      button.setAttribute('aria-busy', String(busy));
    }
    this.querySelector('[data-sticky-add]').textContent = this.selectionConfirmed ? this.labels.buyNow : this.labels.chooseFit;
    this.querySelector('[data-add-copy]').textContent = busy ? this.labels.adding : available ? this.labels.buyNow : this.labels.soldOut;
  }
  handleSubmit = async (event) => {
    if (!event.target.matches('form.bm-product-form')) return;
    event.preventDefault();
    if (this.pending || !event.target.reportValidity()) return;
    if (this.querySelector('input[name="id"]:checked')?.dataset.available !== 'true') return;
    this.pending = true;
    this.setBusy(true);
    const status = this.querySelector('[data-form-status]');
    status.textContent = this.labels.adding;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/add.js`, { method: 'POST', body: new FormData(event.target), headers: { Accept: 'application/json' }, signal: this.abort.signal });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || this.labels.error);
      window.location.assign(`${root}${event.submitter?.hasAttribute('data-buy-now') ? 'checkout' : 'cart'}`);
    } catch (error) {
      if (error.name !== 'AbortError') status.textContent = error.message || this.labels.error;
    } finally {
      this.pending = false;
      if (this.isConnected) this.setBusy(false);
    }
  };
}
if (!customElements.get('blushmallow-shop')) customElements.define('blushmallow-shop', BlushmallowShop);
